import { render, staticRenderFns } from "./bind-client-table.vue?vue&type=template&id=3d4d4024&scoped=true"
import script from "./bind-client-table.vue?vue&type=script&lang=js"
export * from "./bind-client-table.vue?vue&type=script&lang=js"
import style0 from "./bind-client-table.vue?vue&type=style&index=0&id=3d4d4024&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4d4024",
  null
  
)

export default component.exports